export const petFood = [
  {
    src: require('assets/img/food1.png'),
    value: 1
  },
  {
    src: require('assets/img/food2.png'),
    value: 3
  },
  {
    src: require('assets/img/food3.png'),
    value: 5
  }
];
